<template>
   <Head>
    <Meta name="keywords" :content="keywordsContent" />
  </Head>
  <NuxtLoadingIndicator />
  <NuxtLayout>
     <NuxtPage />
  </NuxtLayout>
  <!-- <loginDialog id="login" ref="loginDialogRef" /> -->
  <!-- <loginCom />
  <logoutDialog id="logout" ref="logoutDialogRef" />
  <ProDialog ref="proDialogRef" /> -->
  <OperateRecord ref="operateRecordRef" />
  <UploadFilePopup ref="uploadFilePopupRef" />
</template>

<script setup lang="ts">
// import type LoginDialog from '~/components/LoginDialog/LoginDialog.vue'
// import type LogoutDialog from '~/components/LogoutDialog/index.vue'
import BasicServer from '~/services/BasicServer'
import { NetCode } from '~/types/const'
import { resize } from './viewport.config'
import useSystemLanguageStore from '~/store/modules/systemLaunage'
import useUserStore from '~/store/modules/user'
import useBasicStore from '~/store/modules/basic'
import { Token, SystemLanguageEnum } from '~/types/const'
import { EventHomeMessage } from '~/config/event'
import eventBus from 'vue3-eventbus'
import { storeToRefs } from 'pinia'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import OperateRecord from '~/components/OperateRecord/index.vue'
import UploadFilePopup from '~/components/Dialog/UploadFilePopup/index.vue'
import { useWebVitals } from '~/composables/useWebVitals'
import { useRoutePreload } from '~/composables/useRoutePreload'

const BASE_URL = (useRuntimeConfig().public.pdfOneUrl as string)?.replace(/\/$/, '') || 'https://pdf1.com'
const uploadFilePopupRef = ref<InstanceType<typeof UploadFilePopup>>()
const operateRecordRef = ref<InstanceType<typeof OperateRecord>>()
const userStore = useUserStore()
const baseStore = useBasicStore()
const { userInfo, token }  = storeToRefs(userStore);
const { locale, setLocale, fallbackLocale, t, te } = useI18n()
const { isChina, localtionData} = storeToRefs(baseStore)

const keywordsContent = computed(() => {
  const key = isChina.value ? 'header_mete_china' : 'header_mete'
  return te(key) ? t(key) : ''
})
const { initialize } = useGtag()

const { setLanguage } = useSystemLanguageStore()
let langs = {"zh" : true, "en" : true, "ja" : true, "ko": true, "tw": true, "hi": true, "ar": true, "de": true, "fr": true, "id": true, "itb": true, "uk": true}
// const loginDialogRef = ref<InstanceType<typeof LoginDialog>>()
// import loginDialog from "@/components/LoginDialog/LoginDialog.vue"

// provide('loginDialogRef', loginDialogRef)

const getLangsCode = () => {
  console.log("getLangsCode", locale.value)
  // 直接返回 locale.value，因为 Nuxt i18n 会根据 code 自动找到对应的文件
  return locale.value
}

// useHead({
//   script: [{innerHTML: `(function(c,l,a,r,i,t,y){
//         c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
//         t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
//         y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
//     })(window, document, "clarity", "script", "nvoxpflm51");`},
//     {innerHTML:`CRISP_RUNTIME_CONFIG = {locale : "${getLangsCode()}"};window.$crisp=[];window.CRISP_WEBSITE_ID="fa399f94-5bcf-45d3-9d59-e91f7f1cda8c";(function(){d=document;s=d.createElement("script");s.src="https://client.crisp.chat/l.js";s.async=1;d.getElementsByTagName("head")[0].appendChild(s);})();`}
//   ,{src: 'https://accounts.google.com/gsi/client', onerror: ((error)=>{   }), async: true, defer: true}]
// })

function setClarity (deviceId) {
  let userIdentify = deviceId
  if (token.value && userInfo.value.id) {
    userIdentify = userInfo.value.id
  }
  if (window.clarity) {
    window.clarity("identify", `${userIdentify}`)
  }
  if (window.$crisp) {
    if (userInfo.value.email) {
      window.$crisp.push(["set", "user:email", [userInfo.value.email]]);
    }
    window.$crisp.push(["set", "user:nickname", [`web-${userIdentify}`]]);
  }
}

const handleOperateRecordEvent = (data?: { fileRecordId?: number }) => {
  const recordId = data?.fileRecordId
  operateRecordRef.value?.operateRecordOpen(recordId)
}

const handleUploadFileEvent = (data?: { file?: File, operateRecordItem?: any, source?: string }) => {

  const file = data?.file
  const sourceType = data?.source
  uploadFilePopupRef.value?.open(file,'',sourceType)
}

const closeUploadFilePopup = () => {
  uploadFilePopupRef.value?.close()
}
// 加载第三方脚本的函数
const loadThirdPartyScripts = () => {
  return new Promise((resolve) => {
    // 动态加载 useHead 中的脚本
    useHead({
      script: [
        // {innerHTML: `(function(c,l,a,r,i,t,y){
        //       c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        //       t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        //       y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        //   })(window, document, "clarity", "script", "nvoxpflm51");`},
        // {innerHTML:`CRISP_RUNTIME_CONFIG = {locale : "${getLangsCode()}"};window.$crisp=[];window.CRISP_WEBSITE_ID="fa399f94-5bcf-45d3-9d59-e91f7f1cda8c";(function(){d=document;s=d.createElement("script");s.src="https://client.crisp.chat/l.js";s.async=1;d.getElementsByTagName("head")[0].appendChild(s);})();`},
        {src: 'https://accounts.google.com/gsi/client', onerror: ((error)=>{  console.log('google load error', error); }), async: true, defer: true}
      ]
    })
    // 等待 Google 脚本加载完成
    const checkGoogleLoaded = () => {
      if (window.google) {
        resolve()
      } else {
        setTimeout(checkGoogleLoaded, 100)
      }
    }
    
    // 设置超时，避免无限等待
    setTimeout(() => {
      resolve()
    }, 5000)
    
    checkGoogleLoaded()
  })
}

const initializeApp = () => {
  // isChina.value = false
  isChina.value = useCookie("doclingo_user_is_china").value && useCookie("doclingo_user_is_china").value.toString().toLowerCase() == "true" ? true : false

  initialize(`${useRuntimeConfig().public.gtagId}`)
  
  let localDeviceId = localStorage.getItem("deviceId")
  console.log("localDeviceId", localDeviceId)
  if (localDeviceId) {
    localStorage.setItem("deviceId", localDeviceId)
  }else {
    // 获取设备ID
    try {
      const fpPromise = FingerprintJS.load()
      fpPromise.then(fp=> fp.get()).then(result=>{
        let requestID= result.visitorId
        let deviceId = localStorage.getItem("deviceId")
        if (!deviceId) {
          localStorage.setItem("deviceId", requestID)
          deviceId = requestID
          console.log('visitorid',requestID)
        }
        setClarity(deviceId)
      })
    }catch (e) {
      console.log('visitorid error==',e)
    }
  }

  // 这里切换页面的时候，重新获取用户信息
  document.addEventListener('visibilitychange', function (event) {
    if (!document.hidden) {
      // let isDev = process.env.NODE_ENV === 'development'
      // token.value = isDev ? useCookie(Token).value : getCrossDomainCookie(Token).value || ""
      // if (token.value.length > 0) {
      //   userStore.getUserInfo()
      // }
    }
  })

  BasicServer.getCurrentLocation().then((data)=>{
    if (data.status == 'success') { 
      if (data.data.country.code == 'CN' || data.data.country.code == 'zh') {
        isChina.value = true
      }else {
        isChina.value = false
      }
      baseStore.setLocaltion(data.data.country.code)
    }
  })
}

const onEventInit = () => {
  eventBus.on(EventHomeMessage.operateRecordClick, handleOperateRecordEvent)
  eventBus.on(EventHomeMessage.uploadFileClick, handleUploadFileEvent)
  eventBus.on(EventHomeMessage.closeUploadFilePopup, closeUploadFilePopup)
}

const onEventDestroy = () => {
  eventBus.off(EventHomeMessage.operateRecordClick, handleOperateRecordEvent)
  eventBus.off(EventHomeMessage.uploadFileClick, handleUploadFileEvent)
  eventBus.off(EventHomeMessage.closeUploadFilePopup, closeUploadFilePopup)
}

onUnmounted(() => {
  onEventDestroy()
  window.removeEventListener('resize', () => {
    resize(viewport.breakpoint?.value.includes('desktop') ? 'desktop' : 'mobile')
  })
})

const viewport = useViewport()
onMounted( async () => {  
  // 初始化连接错误检测
  // initConnectionErrorDetection()
  // 1. 首先加载第三方脚本
  // await loadThirdPartyScripts()
  initializeApp()
  window.addEventListener('resize', () => {
    baseStore.setIsDesktop(viewport.breakpoint?.value.includes('desktop'))
    resize(viewport.breakpoint?.value.includes('desktop') ? 'desktop' : 'mobile')
  })
})

onBeforeMount(()=>{
  baseStore.setIsDesktop(viewport.breakpoint?.value.includes('desktop'))
  resize(viewport.breakpoint?.value.includes('desktop') ? 'desktop' : 'mobile')
  // 初始化事件监听
  onEventInit()
})

useHead({
  meta: [],
  // GEO 优化：全局注入 Organization + WebSite Schema，帮助 AI 引擎识别品牌
  script: [
    {
      type: 'application/ld+json',
      innerHTML: JSON.stringify({
        '@context': 'https://schema.org',
        '@graph': [
          {
            '@type': 'Organization',
            '@id': `${BASE_URL}/#organization`,
            name: 'PDF-one',
            url: BASE_URL,
            logo: {
              '@type': 'ImageObject',
              url: `${BASE_URL}/logo.png`,
            },
          },
          {
            '@type': 'WebSite',
            '@id': `${BASE_URL}/#website`,
            name: 'PDF-one',
            url: BASE_URL,
            publisher: { '@id': `${BASE_URL}/#organization` },
          },
        ],
      }),
    },
  ],
})
useTheme()
useWebVitals()
useRoutePreload()
// 初始化第三方应用
appMountInit()
appMountInterfaceInit()
</script>
<style scoped lang="scss">
</style>
